import classNames from 'classnames';
import type { IntlKey } from 'locales';
import { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

interface LinkButtonProps {
  children: ReactNode;
  className?: string;
  iconClassName?: string;
  title: IntlKey;
  subtitle: IntlKey;
  url: string;
}

const StyleDiv = styled.div`
  width: 4rem;
  height: 4rem;
`;

export const LinkButton: FC<LinkButtonProps> = ({ children, title, subtitle, url, iconClassName, className }) => {
  const { formatMessage } = useIntl();
  return (
    <div className={classNames('d-flex', className)}>
      <StyleDiv
        className={classNames('rounded-circle  d-flex align-items-center justify-content-center mb-4', iconClassName)}
      >
        {children}
      </StyleDiv>
      <div className="d-flex flex-column justify-content-start align-items-start ms-4 mt-2">
        <a className="text-primary" href={url} target="_blank">
          <h5>{formatMessage({ id: title })}</h5>
        </a>
        <span>{formatMessage({ id: subtitle })}</span>
      </div>
    </div>
  );
};
